import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import CreateSupplierMasterModal from "../../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import { useNavigate } from "react-router-dom";
import { addPoDetailNumber } from "../../../../redux/feature/supplier_app/purchasingSlice";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { SearchField } from "../../../../Components/formElements/SearchField";
import {
  currencyFormat,
  formatDateTime,
  formatDateWithAMPM,
} from "../../../../common/Validations";
import QualityCancelModal from "./QualityCancelModal";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import {
  getQualityCheckList,
  qualityCheckNr,
} from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";

const QualityCheckListMRV5 = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Quality");
  localStorage.setItem("submenu", "Quality Check");

  // eslint-disable-next-line
  let goods_received_noteDataTable = useSelector(
    (state) => state?.purchasing?.goods_received_note?.pagination,
  ); // goods_received_noteDataTable Details from Store

  let module = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.GRN?.module,
  ); // config Details from Store

  let poDocData = useSelector((state) => state?.customer?.qualityCheck);
  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");
  const [activeFilters, setActiveFilters] = useState([]);

  /* Modal Function */
  // eslint-disable-next-line
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  useEffect(() => {
    setData(poDocData?.data);
  }, [poDocData]);

  // const handlePageChange = (page) => {
  //   let obj = {
  //     queryName: "getQualityCheckList",
  //     page: page,
  //     per_page: getNewPerPage,
  //     searchTerm: getCommonSearchTxt,
  //   };

  //   dispatch(getQualityCheckList(obj));
  // };

  // Common Search Function on button
  const handlePageChange = (page) => {
    let obj = {
      queryName: "getQualityCheckList",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {}, // ← add
    };
    dispatch(getQualityCheckList(obj));
  };
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     queryName: "getQualityCheckList",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(getQualityCheckList(obj));
  // };
  const handleSearchFuncApi = async () => {
    setActiveFilters([]); // ← clear filters when searching
    let obj = {
      queryName: "getQualityCheckList",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getQualityCheckList(obj));
  };

  // const handlePerRowsChange = async (newPerPage, page) => {
  //   let obj = {
  //     queryName: "getQualityCheckList",
  //     page: page,
  //     per_page: newPerPage,
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   setNewPerPage(newPerPage);
  //   dispatch(getQualityCheckList(obj));
  // };
  const handlePerRowsChange = async (newPerPage, page) => {
    setNewPerPage(newPerPage);
    let obj = {
      queryName: "getQualityCheckList",
      page: page,
      per_page: newPerPage, // ← was correct already
      searchTerm: getCommonSearchTxt,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {}, // ← add
    };
    dispatch(getQualityCheckList(obj));
  };
  useEffect(() => {
    const obj = {
      queryName: "getQualityCheckList",
      module: "",
      page: 1,
      per_page: 10,
    };

    dispatch(getQualityCheckList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const detailedPage = (qualityCHeckNr) => {
    dispatch(qualityCheckNr(qualityCHeckNr));
    navigate(CustomerConstants.CUSTOMER_V5_QUALITY_CHECK_DETAILS_MR);
  };

  const detailedPagePO = (poNumber) => {
    dispatch(addPoDetailNumber(poNumber));
    navigate(CustomerConstants.CUSTOMER_V5_PURCHASE_ORDER_DETAILS);
  };

  const columns = [
    {
      name: "Quality Check Nr",
      id: "documentNumber",
      dropDown: true,
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },

    {
      name: "Grn  Number",
      id: "grnNr",
      dropDown: true,
      selector: (row) => row.grnNr,
      cell: (row) => (
        <>
          {/* <{row.grnNr} /> */}
          <p className="fw fw-bold">{row.grnNr}</p>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "GRN Date/Time",
      selector: (row) => formatDateTime(row.createdAt) || "--",
      cell: (row) => (
        <div>
          <span>{formatDateWithAMPM(row.createdAt)}</span>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    {
      name: "GRN Value",
      selector: (row) => row.sumOfGrn || "--",
      cell: (row) => (
        <span className="numberFormate  p-0 pt-1 fw-bold m-1">
          {currencyFormat(Number(row.sumOfGrn).toFixed(2))}
          <span className="m-1 p-0 pt-1 fw-bold text-primary ms-1">
            {row.currencyCode}{" "}
          </span>
          {/* <p className="m-0 p-0">{row.currency} </p> */}
        </span>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "PO Number",
      selector: (row) => row.purchasingDocumentNr,
      cell: (row) => (
        <>
          {row.purchasingDocumentNr && (
            <button
              className="btnInfo"
              onClick={() => detailedPagePO(row.purchasingDocumentNr)}
            >
              {row.purchasingDocumentNr}{" "}
            </button>
          )}
          {!row.purchasingDocumentNr && (
            <>
              {" "}
              <p>--</p>{" "}
            </>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Date/Time",
      selector: (row) => formatDateTime(row?.purchasingDocumentDate) || "--",
      cell: (row) => (
        <div>
          <p>{formatDateWithAMPM(row?.purchasingDocumentDate)}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Invoice",
      selector: (row) =>
        formatDateWithAMPM(row?.purchasingDocumentDate) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">{row?.vendorInvoiceNo}</p>
          <p className="p-0 m-0">{row?.vendorInvoiceDate}</p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Total Invoice Amount",
      selector: (row) =>
        formatDateWithAMPM(row?.vendorTotalInvoiceValue) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">{row?.vendorTotalInvoiceValue}</p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "E-Way Bill",
      selector: (row) =>
        formatDateWithAMPM(row?.purchasingDocumentDate) || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-medium">{row?.ewayBillNumber}</p>
          <p className="p-0 m-0">{row?.ewayBillExpiryDate}</p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Delivery Note",
      selector: (row) => row.grnRemark || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Quality CK Cancel",
      selector: (row) => row.qualityCheckStatus,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          {row.grnStatusHeader === "Cancelled" ? (
            <p className="m-0 p-0 pt-1 text-danger fw-bold">
              {row.qualityCheckStatus}{" "}
            </p>
          ) : (
            <p className="m-0 p-0 pt-1 text-success fw-bold">
              {row.qualityCheckStatus}{" "}
            </p>
          )}
          <p className="m-0 p-0 text-danger">{row.cancellationRemark} </p>
        </div>
      ),
    },
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "180px",
    },
    {
      name: "Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "PO Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },

    {
      name: "GRN Quantity",
      cell: (row) => <span>{row.grnQuantity} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "220px",
    },
    {
      name: "PO Nr",
      cell: (row) => <span>{row.purchasingDocumentNr} </span>,
      width: "220px",
    },
    {
      name: "PO Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
    {
      name: "Schedule Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "220px",
    },
  ];
  /* Cancel Modal */
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => {
    setCancelModalStatus(true);
  };
  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };

  /* Handle selected rows */
  const [getSelectedRows, setSelectedRows] = useState([]);
  const handleRowSelected = ({ selectedRows }) => {
    const validRows = selectedRows.filter(
      (item) => item?.grnStatusHeader !== "Cancelled",
    );
    setSelectedRows(validRows);
  };

  const [chatId, setChatId] = useState(null);
  // eslint-disable-next-line
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  const [filterShow, setFilterShow] = useState(false);

  const convertFilterValues = (filterResult) => {
    if (!filterResult || !filterResult.$and) return filterResult;

    const convertedFilter = {
      ...filterResult,
      $and: filterResult.$and.map((filter) => {
        const key = Object.keys(filter)[0];
        const value = filter[key];

        // Check if this is a numeric field
        const numericFields = ["sumOfGrn"]; // Add other numeric fields here

        if (numericFields.includes(key)) {
          // If it's a range filter with $gte and $lte
          if (typeof value === "object" && (value.$gte || value.$lte)) {
            return {
              [key]: {
                ...(value.$gte && { $gte: Number(value.$gte) }),
                ...(value.$lte && { $lte: Number(value.$lte) }),
              },
            };
          }
          // If it's a direct value
          else if (typeof value === "string") {
            return { [key]: Number(value) };
          }
        }

        return filter;
      }),
    };

    return convertedFilter;
  };

  // Update your handleMultiColumnFilter function
  // const handleMultiColumnFilter = (filterResult) => {
  //   // Convert string numbers to actual numbers
  //   const convertedFilter = convertFilterValues(filterResult);

  //   setFilterShow(false);

  //   let obj = {
  //      queryName: "getQualityCheckList",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //   };

  //   // Add filter if exists
  //   if (
  //     convertedFilter &&
  //     convertedFilter.$and &&
  //     convertedFilter.$and.length > 0
  //   ) {
  //     obj.rowFilter = convertedFilter;
  //   }

  //   dispatch(getQualityCheckList(obj));
  // };
  const handleMultiColumnFilter = (filterResult) => {
    const convertedFilter = convertFilterValues(filterResult);

    // Extract array from { $and: [...] } format
    const filtersArray = Array.isArray(convertedFilter)
      ? convertedFilter
      : convertedFilter?.$and || [];

    setActiveFilters(filtersArray); // ← save filters

    const obj = {
      queryName: "getQualityCheckList",
      page: 1,
      per_page: getNewPerPage,
      searchTerm: "",
      rowFilter: filtersArray.length > 0 ? { $and: filtersArray } : {},
    };
    dispatch(getQualityCheckList(obj));
  };
  //  Handle filter cancel
  // const handleFilterCancel = () => {
  //   setFilterShow(false);
  // };
  const handleFilterCancel = () => {
    setFilterShow(false);
    setActiveFilters([]); // ← clear filters
    dispatch(
      getQualityCheckList({
        queryName: "getQualityCheckList",
        page: 1,
        per_page: getNewPerPage,
        searchTerm: "",
      }),
    );
  };

  const columnsForFilter = [
    {
      id: "documentNumber",
      name: "Quality Check Nr",
      selectorKey: "documentNumber",
    },
    {
      id: "grnNr",
      name: "GRN Number",
      selectorKey: "grnNr",
    },
    {
      id: "vendorCode",
      name: "Vendor Code",
      selectorKey: "vendorCode",
    },
    {
      id: "vendorName",
      name: "Vendor Name",
      selectorKey: "vendorName",
    },
    {
      id: "purchasingDocumentNr",
      name: "PO Number",
      selectorKey: "purchasingDocumentNr",
    },
    
    {
      id: "vendorInvoiceNo",
      name: "Invoice Number",
      selectorKey: "vendorInvoiceNo",
    },
    {
      id: "sumOfGrn",
      name: "GRN Value",
      selectorKey: "sumOfGrn",
      numberRange: true,
    },
    {
      id: "createdAt",
      name: "GRN Date",
      selectorKey: "createdAt",
      month: true,
    },
  ];
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Quality Check List</h2>
                <p className="subText">Quality Check List and details</p>
              </Col>
              <Col xs={12} md={2} lg={2} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleMultiColumnFilter}
                onCancel={handleFilterCancel}
                output="and" //  Returns { $and: [...] } format
              />
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                      <span className="iconLogo">QC</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Quality Check List</span>
                      <span className="subHeaderTitle">
                        View of Quality Check List and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={6} md={6} lg={6}>
                        <button
                          className="btnTable"
                          onClick={cancelModalShow}
                          disabled={getSelectedRows.length > 0 ? false : true}
                        >
                          <i className="bi bi-x-circle"></i> Cancel
                        </button>
                      </Col>
                      <Col xs={6} md={1} lg={1}>
                        <POCollabrationCommonFillter />
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={poDocData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                           paginationPerPage={getNewPerPage}    
                         paginationTotalRows={poDocData?.pagination?.total || 0}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateSupplierMasterModal show={modalShow} onHide={() => hideModal()} />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <QualityCancelModal
        title="Cancel the QualityCheck"
        type={module}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        selectedrow={getSelectedRows}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default QualityCheckListMRV5;
